import Result from "@/core/common/Result";
import { IObterMensagemBoasVindasUseCase } from "../ports/ObterMensagemBoasVindasUseCase";
import { inject, injectable } from "inversify";
import {
  type IObterMensagemBoasVindasGateway,
  obterMensagemBoasVindasGatewayDI
} from "../ports/ObterMensagemBoasVindasGateway";

@injectable()
export class ObterMensagemBoasVindasUseCaseAdapter
  implements IObterMensagemBoasVindasUseCase
{
  @inject(obterMensagemBoasVindasGatewayDI)
  private readonly gateway!: IObterMensagemBoasVindasGateway;

  async execute(): Promise<Result<boolean>> {
    const response = await this.gateway.getMensagemBoasVindas();

    if (response.isFailure) return Result.fail(response.error);

    return Result.ok(response.getValue().podeVisualizarMensagemBoasVindas);
  }
}
